import { ForceUpdateInstruction, PlatformKind } from "./types";

export const detectPlatform = (): PlatformKind => {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("mac os") || ua.includes("macintosh")) return "mac";
  if (ua.includes("win")) return "windows";
  return "unknown";
};

export const buildInstructions = (platform: PlatformKind, projectName: string): ForceUpdateInstruction => {
  const projectLabel = projectName || "el proyecto";

  if (platform === "mac") {
    return {
      platform,
      headline: "macOS",
      steps: [
        `Cierra todas las pestañas abiertas de ${projectLabel}.`,
        "Presiona ⌘ + Shift + R para forzar la recarga de la aplicación.",
        "Si el problema persiste, abre una ventana privada (⌘ + Shift + N) e inicia sesión de nuevo."
      ]
    };
  }

  if (platform === "windows") {
    return {
      platform,
      headline: "Windows",
      steps: [
        `Cierra las pestañas abiertas de ${projectLabel}.`,
        "Presiona Ctrl + Shift + R o Ctrl + F5 para forzar la recarga.",
        "Si el problema continúa, abre una ventana en modo incógnito (Ctrl + Shift + N) e inicia sesión otra vez."
      ]
    };
  }

  return {
    platform,
    headline: "Escritorio",
    steps: [
      `Cierra las pestañas activas de ${projectLabel}.`,
      "Realiza una recarga forzada de la página.",
      "Si la versión no cambia, abre una ventana privada y vuelve a iniciar sesión."
    ]
  };
};
